import React from 'react'
import { MenuItem } from '@material-ui/core'

export const Option = props => (
  <MenuItem
    selected={props.isFocused}
    buttonRef={props.innerRef}
    component='div'
    style={{
      fontWeight: props.isSelected ? 700 : 400,
    }}
    {...props.innerProps}
  >
    {props.children}
  </MenuItem>
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/Option/index.js